import Badge, { BadgeProps, BadgeSize } from "@/admin/experiences/badges/Badge"
import { useProductsAdminLearnMode } from "@/core/context/ProductsAdminLearnModeContext"
import { ProductBadgeFragment$key } from "@/main/page/side-bar/temporary-sidebar/__generated__/ProductBadgeFragment.graphql"
import ProductBadgeLearnModeIcon from "./product-badge-learn-mode.svg"
import classes from "./ProductBadge.module.css"

import { TestIDProps } from "@utils/typeUtils"
import { graphql, useFragment } from "react-relay"

interface ProductBadgeProps extends TestIDProps {
  productKey: ProductBadgeFragment$key
  size?: BadgeSize
  isSelected?: BadgeProps["isSelected"]
}

export default function ProductBadge({
  testid,
  productKey,
  size,
  isSelected,
}: ProductBadgeProps) {
  const product = useFragment<ProductBadgeFragment$key>(
    graphql`
      fragment ProductBadgeFragment on Product {
        id
        badge {
          ...BadgeFragment
        }
      }
    `,
    productKey
  )

  const { isViewerInLearnModeForProduct } = useProductsAdminLearnMode()
  const isViewerInLearnMode = isViewerInLearnModeForProduct(product.id)

  return (
    <div
      className={classes.leftIconOuterContainer}
      data-in-learning-mode={isViewerInLearnMode}
      data-is-selected={isSelected}
    >
      <div className={classes.leftIconInnerContainer}>
        <Badge isSelected={isSelected} badgeKey={product.badge} size={size} />
      </div>

      {isViewerInLearnMode && (
        <div
          data-testid={`${testid}.learn-mode-icon`}
          className={classes.learnModeIconContainer}
        >
          <ProductBadgeLearnModeIcon />
        </div>
      )}
    </div>
  )
}
